import React, { PropsWithChildren } from 'react';
import Choose from 'src/components/conditional/Choose';
import Else from 'src/components/conditional/Else';
import When from 'src/components/conditional/When';

interface IfNotProps {
    condition: boolean | (() => boolean) | undefined;
    otherwise?: JSX.Element | (() => JSX.Element);
}

const IfNot = ({ condition, otherwise, children }: PropsWithChildren<IfNotProps>) => (
    <Choose>
        <When condition={condition}>
            {(typeof otherwise === 'function') ? otherwise() : otherwise}
        </When>

        <Else>
            {children}
        </Else>
    </Choose>
);

export default IfNot;
